module.exports = __webpack_public_path__ + "static/media/171-galapagos-islands.f0d6b59a.svg";